import {
  APILibraryTemplatePack,
  type APILibraryTemplatePackResponseType,
  type IAPILibraryTemplatePack,
} from "@/core/data_sources/models/APILibraryTemplatePack";
import { State } from "@/core/data_sources/store/state";

export type LibraryTemplatePacksStateType = {
  list: IAPILibraryTemplatePack[];
  selected: IAPILibraryTemplatePack | null;
  count: number;
};

export class LibraryTemplatePacksState extends State<LibraryTemplatePacksStateType> {
  constructor() {
    super({ list: [], selected: null, count: 0 });
  }

  setTemplatePacks(packs: APILibraryTemplatePackResponseType[]) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, count: 0 }),
      list: packs.map((pack) => new APILibraryTemplatePack(pack)),
    });
  }
  setTemplatePack(pack: APILibraryTemplatePackResponseType | null) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, count: 0 }),
      selected: pack ? new APILibraryTemplatePack(pack) : null,
    });
  }

  setCount(count: number) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, count: 0 }),
      count,
    });
  }

  clear(): void {
    this._observable.next({ list: [], selected: null, count: 0 });
  }
}
